import { Container, Graphics } from 'pixi.js';

interface Particle {
  g: Graphics;
  vx: number;
  vy: number;
  life: number;
  max: number;
  spin: number;
  grow: number;
}

/** Petites particules poolées ; le volume dépend du réglage et des animations réduites. */
export class Particles {
  private live: Particle[] = [];
  private pool: Graphics[] = [];
  budget = 1;

  constructor(private readonly layer: Container) {}

  private take(): Graphics {
    const g = this.pool.pop() ?? new Graphics();
    g.visible = true;
    g.alpha = 1;
    g.scale.set(1);
    this.layer.addChild(g);
    return g;
  }

  burst(x: number, y: number, color: number, count: number, speed: number, size: number, sides = 0, life = 0.5): void {
    const n = Math.round(count * this.budget);
    for (let i = 0; i < n && this.live.length < 600; i++) {
      const g = this.take();
      g.clear();
      const s = size * (0.6 + Math.random() * 0.8);
      if (sides >= 3) g.regularPoly(0, 0, s, sides).fill(color);
      else g.circle(0, 0, s).fill(color);
      g.position.set(x, y);
      const a = Math.random() * Math.PI * 2;
      const v = speed * (0.3 + Math.random() * 0.7);
      const l = life * (0.6 + Math.random() * 0.6);
      this.live.push({ g, vx: Math.cos(a) * v, vy: Math.sin(a) * v, life: l, max: l, spin: (Math.random() - 0.5) * 8, grow: 0 });
    }
  }

  flash(x: number, y: number, color: number, radius: number, life = 0.12): void {
    if (this.budget <= 0) return;
    const g = this.take();
    g.clear();
    g.circle(0, 0, radius).fill({ color, alpha: 0.7 });
    g.position.set(x, y);
    this.live.push({ g, vx: 0, vy: 0, life, max: life, spin: 0, grow: 2.5 });
  }

  update(dt: number): void {
    for (let i = this.live.length - 1; i >= 0; i--) {
      const p = this.live[i];
      p.life -= dt;
      if (p.life <= 0) {
        p.g.visible = false;
        this.layer.removeChild(p.g);
        this.pool.push(p.g);
        this.live.splice(i, 1);
        continue;
      }
      const k = p.life / p.max;
      p.g.x += p.vx * dt;
      p.g.y += p.vy * dt;
      p.vx *= 0.92;
      p.vy *= 0.92;
      p.g.rotation += p.spin * dt;
      p.g.alpha = k;
      if (p.grow) p.g.scale.set(1 + (1 - k) * p.grow);
    }
  }
}
